<template>
  <v-snackbar id="snackbar-download" :timeout="0" :value="getDownloadList.length > 0" right
    auto-height>
    <button id="clearAll" @click="REMOVE_DOWNLOAD_LIST()">Clear All</button>
    <div class="expansion-wrapper">
      <v-expansion-panel popout inset>
        <v-expansion-panel-content v-for="(item, i) in getDownloadList" :key="i">
          <div slot="header">
            <v-icon color="orange" @click.stop="SET_DOWNLOAD_LIST({id: item.id})" v-if="!item.downloading">
              close</v-icon>
            <v-progress-circular v-if="item.downloading" :size="20" indeterminate color="primary">
            </v-progress-circular>
            <span v-if="item.downloading" class="pl-3">downloading ...</span>
            <span v-if="!item.downloading && item.status == 'success'" class="pl-3">download
              completed</span>
            <span v-if="!item.downloading && item.status == 'fail'" class="pl-3">download
              failed</span>
          </div>
          <v-card>
            <v-card-text>{{`Plant Id: ${item.plantId}`}}</v-card-text>
            <v-card-text>{{`Block Id: ${item.blockId}`}}</v-card-text>
            <v-card-text>{{`Device: ${item.device}`}}</v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-snackbar>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapGetters('settings', ['getDownloadList'])
  },
  methods: {
    ...mapMutations('settings', ['SET_DOWNLOAD_LIST', 'REMOVE_DOWNLOAD_LIST']),
  },
}
</script>

<style scoped>
#snackbar-download .expansion-wrapper {
  width: 400px;
  max-height: 300px;
  overflow-y: auto;
  text-align: right;
}

#clearAll {
  font-size: 16px;
}

#clearAll:hover {
  color: orange !important;
}
</style>
